import { useSite } from "@/context/ContentContext";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-3xl italic text-gold/50 md:px-12 md:text-5xl">
          {item}
        </span>
        <span aria-hidden="true" className="h-2 w-2 rotate-45 bg-gold/30" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  const D = useSite();
  const items = D.marquee.length ? D.marquee : ["Ada"];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-gold/10 bg-cream-100/60 py-10 md:py-14"
    >
      <div className="flex w-max animate-marquee">
        <Row items={items} />
        <Row items={items} />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-cream-50 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-cream-50 to-transparent" />
    </div>
  );
}
